import React, { useState } from "react";
import { Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/lab';

export const MuiDatePicker = (props) => {

    const [selectedDate, setSelectedDate] = useState(props.initialDate || new Date());
    // const [selectedDate, setSelectedDate] = useState(new Date());

    return (
        <Grid container spacing={2} sx={{ pl: props.paddingH, pr: props.paddingH, pt: props.paddingV, pb: props.paddingV }}>
            
            <Grid item xs={12}>

                <DatePicker 
                    onChange={ (newValue) => {
                        setSelectedDate(newValue);
                        const target = {name:props.name, value:newValue};
                        props.parentCallback({target});
                    }}
                    id={props.name}
                    label={ props.label }
                    name={props.name}
                    renderInput={ (params) => <TextField { ...params } /> }
                    value={ selectedDate }
                    inputFormat="dd/MM/yyyy"
                />

            </Grid>

    </Grid>
    );
};
